import React from 'react'
import { Panel, Container, CheckBoxField, Label, TextField, Toolbar, Button, TextAreaField, FieldSet, ComboBoxField, Image, DateField, NumberField } from "@sencha/ext-modern"
import { connect } from 'react-redux'
import { compose } from 'redux'
import Message from 'tyan/components/Message'
import { doGetReportApprovalTime, doSubmitReportApprovalTime } from 'tyan/reducers/actions'
import TreeListView from 'tyan/components/TreeListView'
import { showFile, getFileIcon } from 'tyan/public/index'
import { nullDate, equalFuns, reconfigButton } from 'tyan/public/utility'
import 'tyan/css/DetalApproval.css';

Ext.require([
	'Ext.MessageBox',
	'Ext.Toast',
])
Ext.require('Ext.MessageBox')
const style = {
	outer: {
		backgroundColor: "#f5f5f5",
		padding: "10px",
	},
	innerContainer: {
		borderRadius: "10px",
		backgroundColor: "#ffffff",
		padding: "10px",
		width: "100%",
	},
	titleContainer: {
		borderBottom: "1px solid #f5f5f5",
	},
}
class ReportApprovalTime extends React.Component {
	state = {
		report: null,
		errorMessage: null,
		changeValues: {},
		reportMessage: null,
		readOnly: false,
	}

	componentDidMount() {
		const { doGetReportApprovalTime, match: { params: { reportID } } } = this.props
		doGetReportApprovalTime({
			reportID,
			onEnd: ({ report, errorMessage }) => {
				this.setState({ report, errorMessage })
			}
		})
	}

	handleSubmitTask = (reportID, action, comment) => {
		const { doSubmitReportApprovalTime } = this.props
		const { changeValues } = this.state
		this.setState({ readOnly: true })
		doSubmitReportApprovalTime({
			reportID,
			action,
			comment,
			changeValues,
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					this.setState({ errorMessage })
				} else {
					window.close()
				}
			}
		})
	}

	isEqual = (value1, value2) => (JSON.stringify(Array.isArray(value1) && value1.sort() || value1) === JSON.stringify(Array.isArray(value2) && value2.sort() || value2))

	handleBack = () => {
		const { history, match: { params: { source } } } = this.props
		Ext.toast(`执行成功！`)
		history.goBack()
	}

	//日期控件
	dateRender = ({ item, level }) => {
		const d = item.value && item.value !== nullDate && new Date(item.value) || null
		const value = d && new Date(d.getFullYear(), d.getMonth(), d.getDate())
		return <DateField key={item.name}
			labelAlign="left"
			margin={"0 0 0 " + (level * 28)}
			label={"<font color='black'>" + item.name + "：</font>" || null}
			labelWidth="auto"
			name={item.name}
			value={value}
			width="100%"
			noLocale='false'
			onChange={(obj, value) => this.handlerDateChange({ name: item.name, value })} />
	}
	handlerDateChange = ({ name, value }) => {
		const { changeValues } = this.state
		const newValue = value && Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()).valueOf()
		if (!this.isEqual(newValue, changeValues[name])) {
			this.setState({ changeValues: { ...changeValues, [name]: newValue } })
		}
	}


	showReport = report => {
		return (
			<Container layout={{ type: "vbox", align: "left" }} style={style.innerContainer} padding="0" >
				{report && report.fields.map((item, index) => {

					switch (item.type) {
						case "attachment":
							return (
								<Container key={index} layout={{ type: 'hbox', pack: 'start' }}>
									<Label cls="label" key={index} html={item.name + '：'} padding="12 0 12 0" />
									<Button ui="confirm round" iconCls={"x-fa fa-file-" + getFileIcon('.' + item.ext)} cls="file-button" text="详情..." height="80%" handler={() => showFile({ path: item.path, ext: item.ext })} />
								</ Container>)
						case "tree":
							return (
								<TreeListView key={item.name} data={item.children} />)
						case "logs":
							return (
								<Container layout={{ type: 'vbox', pack: 'start' }} key={index}>
									<Label cls="label" key={index} html={item.name + '：'} />
									{item.list && item.list.map((o, i) => (
										<Label style={style.titleContainer} cls="label" key={i} html={o.content} padding="8 0 0 0" />
									))}
								</Container>
							)
						case "attachmentList":
							return (
								<Container layout={{ type: 'hbox', pack: 'start' }} key={index}>
									<Label cls="label" key={index} html={item.name + '：'} />
									<Container layout={{ type: 'vbox', pack: 'start', }} padding="0 0 0 10" >
										{item.list && item.list.map((o, i) => (
											<Container key={i} layout={{ type: 'vbox', pack: 'start', }} width="100%" padding="0 0 0 0" >
												<Button ui="confirm round" iconCls={"x-fa fa-file-" + getFileIcon('.' + o.ext)} cls="file-button" text={o.file} height="80%" handler={() => showFile({ path: o.path, ext: o.ext })} />
											</ Container>
										)
										)}
									</ Container>
								</Container>
							)
						case "date":
							return (this.dateRender({ item: item, level: 0 }))
						default:
							return (<Label cls="label" key={index} html={item.name + '：' + item.value} padding="0 0 0 0" />)
					}
				})}
			</ Container>
		)
	}

	render() {
		const { report, errorMessage, reportMessage } = this.state
		if (errorMessage) {
			return <Message text="数据加载失败" subText={errorMessage} />
		} else if (!report) {
			return <Message text="数据加载中..." />
		}

		const panelProps = {
			height: "100%",
			margin: '0 0 0 0',
			padding: '0 0 0 0'
		}

		return (
			<Panel shadow layout="vbox" {...panelProps}>
				<Container layout="vbox" flex={4} scrollable style={style.outer}>
					{this.showReport(report)}
				</Container>
				<Toolbar shadow={false} docked="bottom" layout={{ type: 'hbox', pack: 'right' }}>
					<Button ui="action raised" text="批准" margin="5" disabled={this.state.readOnly} handler={() => Ext.Msg.show({
						title: "批准确认", message: "确定要批准吗？",
						buttons: [{ itemId: "ok", text: "确定" }, { itemId: "cancel", text: "取消" }],
						fn: buttonID => buttonID == "ok" && this.handleSubmitTask(report.reportID, '批准中.批准', '')
					})} />
				</Toolbar>
			</Panel>
		)
	}
}

const mapStateToProps = ({ }) => ({})

export default compose(
	connect(mapStateToProps, { doGetReportApprovalTime, doSubmitReportApprovalTime })
)(ReportApprovalTime)